import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { createRequiredContext } from '~/utils/createRequiredContext';

type ApplicantAttributionContextType = {
    attribution: APPLICANT_ATTRIBUTION;
};

const [useApplicantAttributionContext, ContextProvider] =
    createRequiredContext<ApplicantAttributionContextType>('ApplicantAttributionContext');

type Props = PropsWithChildren<{
    attribution: APPLICANT_ATTRIBUTION;
}>;

const ApplicantAttributionContextProvider: React.FC<Props> = ({ attribution, children }) => {
    const value = useMemo(() => ({ attribution }), [attribution]);

    return <ContextProvider value={value}>{children}</ContextProvider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export { useApplicantAttributionContext };
export default ApplicantAttributionContextProvider;
